var _rect, _rect2, _rect3, _rect4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPassport = function SvgPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01074,
    width: 36.201,
    height: 56,
    rx: 4,
    transform: "rotate(-7.9557 1 6.01074)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01025,
    width: 44,
    height: 56,
    rx: 4,
    fill: "",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2842,
    y: 49.0564,
    width: 14.25,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2842,
    y: 43.8745,
    width: 19.4318,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0006,
    cy: 26.9376,
    r: 7.56898,
    stroke: "currentColor",
    strokeWidth: 2
  })));
};
export { SvgPassport as ReactComponent };